import { createTheme } from '@mui/material/styles'
import { BREAKPOINT_VALUES, STYLE_UNITS, UI_SCALE } from './constants'
import { globalStyles } from './globalStyles'
// Leaf import (not the `@/components` barrel) to avoid a styles <-> components cycle.
import { textConfig } from '@/components/Data/Text/Text.style'
import { palette } from './palette'

export const theme = createTheme({
  cssVariables: true,
  // Scale all sx spacing (p/m/gap…) to the 80% density.
  spacing: STYLE_UNITS.SPACING_MULTIPLIER * UI_SCALE,
  // Scale all `borderRadius: n` shorthands to match.
  shape: {
    borderRadius: STYLE_UNITS.BORDER_RADIUS_MULTIPLIER * UI_SCALE,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: BREAKPOINT_VALUES.SM + 1,
      md: BREAKPOINT_VALUES.MD + 1,
      lg: BREAKPOINT_VALUES.LG + 1,
      xl: BREAKPOINT_VALUES.XL + 1,
      xxl: BREAKPOINT_VALUES.XXL + 1,
      xxxl: BREAKPOINT_VALUES.XXXL + 1,
    },
  },
  palette,
  typography: {
    fontFamily: 'var(--font-primary)',
    ...textConfig,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: globalStyles,
    },
  },
  zIndex: {
    aboveDrawer: 1201,
  },
})
